import * as React from 'react'
import './page.less'

// tslint:disable-next-line: no-var-requires
const errorCloudStumbled = require('../../../../images/icons/Server-Error-Large.svg')

interface IErrorState {
  hasError: boolean
}

interface IErrorProps {
  children?: React.ReactNode
}

export class AsyncLoadErrorBoundary extends React.Component<IErrorProps, IErrorState> {
  public static getDerivedStateFromError(error) {
    return {hasError: true}
  }

  constructor(props) {
    super(props)
    this.state = {hasError: false}
  }

  public render() {
    if (this.state.hasError) {
      return (
        /* TODO : This is dummy placeholder for async load error screen.
                  Should be replaced with screen once provided by UX team
        */
        <div className="async-error-page">
          <div className="tc-async-page-stumbled">
            <img className="page-stumbled-image" src={errorCloudStumbled} />
            <div className="tc-async-page-stumbled-text text-bold">Oops!</div>
            <div className="tc-async-page-stumbled-text">
              It looks like the server just stumbled. If this error persists please reload the page.
            </div>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}
